import AdvancedController from "./advanced-controller"
import { gsap } from 'gsap'
import { Breakpoints } from "../utils/breakpoints";


const NAV_TOGGLE_BREAKPOINT = 'sm'

export default class ToggleController extends AdvancedController {

  static targets = ['content', 'block'];
  static values = {
    windowWidth: Number,
  }

  static classes = ["active"]

  _isOpen = false

  connect() {
    super.connect()
    this.breakpoints = new Breakpoints();

    if (this.blockTarget.classList.contains('expandable-orientation--vertical')) {
      this.blockTarget.classList.add('change-orientation-on-mobile');
    }

    this.resize();
  }


  resize() {
    if (this.breakpoints.breakpointDown(NAV_TOGGLE_BREAKPOINT) && this.blockTarget.classList.contains('change-orientation-on-mobile')) {
      this.blockTarget.classList.remove('expandable-orientation--vertical');
      this.blockTarget.classList.add('expandable-orientation--horizontal');
      if (this._isOpen) {
        this._open();
      }
    } else if (this.breakpoints.breakpointUp(NAV_TOGGLE_BREAKPOINT) && this.blockTarget.classList.contains('change-orientation-on-mobile')) {
      this.blockTarget.classList.remove('expandable-orientation--horizontal');
      this.blockTarget.classList.add('expandable-orientation--vertical');
      if (this._isOpen) {
        this._open();
      }
    }
  }

  onToggleClick(e) {
    e.preventDefault();
    this._isOpen = !this._isOpen
    if (this._isOpen) {
      this._open();
    } else {
      this._close();
    }
  }

  _open() {
    this.element.classList.add(this.activeClass)

    this.contentTarget.style.display = 'block'
    this.contentTarget.style.height = 'auto'
    const h = this.contentTarget.offsetHeight
    console.log(this.contentTarget, this.contentTarget.parentElement)
    if (this.contentTarget.classList.contains('expandable__content--vertical')) {
      gsap.fromTo(this.contentTarget, { height: '0px', paddingBottom: '0px', }, { height: `${h}px`, paddingBottom: '2.25rem' })

    } else {
      gsap.fromTo(this.contentTarget, { height: '0px' }, { height: `${h}px` })
    }
  }

  _close() {
    this.element.classList.remove(this.activeClass)

    const h = this.contentTarget.offsetHeight


    if (this.contentTarget.classList.contains('expandable__content--vertical')) {

      gsap.fromTo(this.contentTarget, { height: `${h}px`, paddingBottom: '2.25rem' }, { height: '0px', paddingBottom: '0px', onComplete: () => (this.contentTarget.style.display = "none") })
    } else {
      gsap.fromTo(this.contentTarget, { height: `${h}px` }, { height: '0px' })
    }
  }

}
